function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Cart = function Cart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size <= 16 ? 0.8 : 0,
    stroke: props.size <= 16 ? props.color ? props.color : "#222222" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    d: "M9.41 17.95h11.54c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H9.41c-1.188 0-1.65-1.53-1.804-2.265l11.704-.335c3.31-.43 3.31-3.59 3.31-5.69V5.13c0-.41-.34-.75-.75-.75H5.775L5.49 2.86a.76.76 0 0 0-.74-.61H2.12c-.41 0-.75.34-.75.75s.34.75.75.75h2.01l.274 1.457q.006.06.022.117l1.535 8.167a.7.7 0 0 0 .036.195l.063.334c.16 1.46 1.06 3.93 3.35 3.93m-2.08-5.268 11.87-.332c1.79-.23 1.92-1.74 1.92-4.19V5.88H6.056z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    d: "M9.89 22.07a1.25 1.25 0 1 1 0-2.501 1.25 1.25 0 0 1 0 2.5M17.97 20.82a1.25 1.25 0 1 0 2.5-.001 1.25 1.25 0 0 0-2.5 0"
  }));
};
export default Cart;
Cart.displayName = 'Cart';